import type { FAQItem, ResourcePageSeo } from "../resource-seo";

export const faqs: FAQItem[] = [
  {
    question: "What is MindMyJob?",
    answer:
      "MindMyJob is an AI job search platform. It helps you build and tailor your resume, find matching jobs, apply automatically or in one click, reach recruiters and prepare for interviews, all from one dashboard and a Chrome extension.",
  },
  {
    question: "How do I get started?",
    answer:
      "Create an account, install the Chrome extension, connect the job boards you use and complete your profile with your resume, target roles and locations. Then pick a matching job and send your first application. The How to Use page walks through each step.",
  },
  {
    question: "Which job boards does MindMyJob work with?",
    answer: "LinkedIn, Naukri, Indeed, Foundit, Instahyre and Internshala.",
  },
  {
    question: "What do the AI agents do?",
    answer:
      "Auto Apply finds matching roles and applies on a schedule you set. Live Apply shows jobs minutes after they are posted and applies to the ones you pick. Tailored Apply rewrites your resume for each job. Inbox Apply finds the recruiter and sends a short, personal note.",
  },
  {
    question: "Will Auto Apply send applications I don't want?",
    answer:
      "No. It only applies to roles that match your titles, locations and minimum match score. You can add companies to a never-apply list, set a daily limit, or turn on review mode to approve each application first.",
  },
  {
    question: "Can I pause or stop an agent?",
    answer:
      "Yes. Pause or stop any agent from your dashboard at any time. Applications already sent stay in your tracker.",
  },
  {
    question: "Does MindMyJob change my resume?",
    answer:
      "Your master resume stays as you wrote it. When an agent tailors a resume, it creates a separate copy for that job and you can see what changed.",
  },
  {
    question: "Is my data private?",
    answer:
      "Your resume and profile are used only to find jobs and apply on your behalf. We do not sell your data. You can download or delete your data from your account settings.",
  },
  {
    question: "Can I use MindMyJob for free?",
    answer:
      "Yes. You can create a free account and use core tools such as the resume builder, resume scoring and the job board. Paid plans add more agent applications, tailored resumes and mock interviews. See the Pricing page for current limits.",
  },
  {
    question: "How do credits work?",
    answer:
      "Some actions, such as tailored resumes and AI mock interviews, use credits from your plan. Your usage for the current cycle is shown on your account page, and limits reset when your plan renews.",
  },
  {
    question: "Can I upgrade, downgrade or cancel?",
    answer:
      "Yes, from your account page. Upgrades apply straight away. Downgrades and cancellations take effect at the end of the period you have paid for, and you keep access until then.",
  },
  {
    question: "How do I get an invoice?",
    answer:
      "Every payment has an invoice you can download from Plan and billing in your account settings.",
  },
  {
    question: "How do I contact support?",
    answer:
      "Send a message from the Support page. A member of our team will reply, usually within the same working day.",
  },
];

export const seo: ResourcePageSeo = {
  slug: "faq",
  name: "FAQ",
  title: "MindMyJob FAQ: Setup, AI Agents and Billing",
  description:
    "Answers to common questions about MindMyJob: getting started, supported job boards, how the AI agents work, privacy, plans, credits and support.",
  keywords: [
    "mindmyjob faq",
    "mindmyjob help",
    "how does auto apply work",
    "ai job application tool faq",
    "auto apply jobs safe",
    "mindmyjob pricing",
    "mindmyjob chrome extension",
    "mindmyjob support",
    "cancel mindmyjob subscription",
    "job application automation questions",
  ],
  ogImage: "/assets/images/resources/faq/help-center.png",
  ogImageAlt:
    "MindMyJob help centre with answers about AI agents, billing and setup",
  featureList: [
    "Getting started guide",
    "AI agent controls explained",
    "Supported job boards",
    "Plans, credits and billing",
    "Privacy and data",
    "Human support",
  ],
  faqs,
};
